/**
 * StickersRepository manages :
 * - used stickers
 * - recommended stickers (with same theme_category)
 * - search result stickers
 */
fx.ns("repositories", class StickersRepository extends fx.ModelArray {

    constructor(model)
    {
        super([]);

        this._cacheTagsSearch = {};
        this._cache = {};
        
        this.endpoint = "/app/stickers";

        this._fromRecommended = 0;
        this._lastSearch = "";

        this.internalSort = this._sortByPosition;

        this.set("stickersTag", new fx.ModelArray([]));
        this.set("defaults", new fx.ModelArray([]));
    }

    get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

    get recommended()
    {
        return this._recommendedStickers;
    }

    get more()
    {
        if (this._lastSearch === "")
            return this._fromRecommended;
        else
            return this._fromSearch;
    }

    get bookid()
    {
        return this._bookid;
    }

    set bookid(val)
    {
        this._bookid = val;
    }

    get themeid()
    {
        return this._themeid;
    }

    set themeid(val)
    {
        this._themeid = val;
    }

    get categories()
    {
        return this._categories;
    }

    set categories(val)
    {
        this._categories = val;
    }

    get defaults()
    {
        return [];
    }

    init(data)
    {
        super.init([]);

        if (!this._recommendedStickers)
        {
            this._recommendedStickers = new fx.ModelArray();
            this._recommendedStickers.parentModel = this;
        }

        this._fromRecommended = data.more;
        this._recommendedStickers.init(data.data);
         
        this.addItem( this._recommendedStickers, true );
    }

    loadRecommended(book)
    {
        if (this._fromRecommended === false)
            return;

        this.post(  { 
            action:"recommended", 
            themeid : book.themeid,
            bookid : book.id,
            from : this._fromRecommended,
            count : 30
        }, 
        this._loadRecommended);
    }

    _loadRecommended(data)
    {
        if (data.error)
            this.event("load-recommended-sticker-error")
        else
        {
            this._fromRecommended = data.more;
            this._recommendedStickers.addItem(data.data, true);
            this.addItem(data.data, true);
            this.trigger("loaded");
        }
    }

    load( category_id, id_lang )
    {
        if (this._cache[category_id + "-" + id_lang ])
        {
            this.event("stickers-loaded", this);
            return;
        }
            

        this.post(  { 
                    action:"load", 
                    category_id : category_id,
                    id_lang : id_lang
                }, 
                this._loaded);
    }

    _loaded(data)
    {
        if (data.error)
            this.event("load-stickers-error", data);
        else
        {
            if (data.length > 0)
            {
                this.addItem(data, false);
                this._cache[data[0].theme_category_id + "-" + data[0].id_lang] = data;                
            }

            this.event("stickers-loaded", data);
        }
    }

    loadDefaults()
    {
        this.post(  { 
            action:"defaults",
        }, 
        this._loadedDefaults);
    }

    _loadedDefaults(data)
    {
        if (data.error)
            this.event("load-stickers-error", data);
        else
        {
            if (data.length > 0)
                this.stickersTag.addItem(data, true);

            this.event("default-stickers-loaded", data);
        }
    }

    loadDefaultTag(themetagid)
    {
        this.post(  { 
            action:"loaddefaults",
            theme_tag_id :themetagid
        }, 
        this._loadedDefaultTag);
    }

    _loadedDefaultTag(data)
    {
        if (data.error)
            this.event("load-stickers-error", data);
        else
        {
            this.defaults.removeAll(true);

            if (data.length > 0)
            {
                // add only new theme_tag_id & id
                for(let i = 0; i < data.length; i++)
                {
                    let sticker = data[i];
                    if (!this.defaults.find({id : sticker.id, theme_tag_id : sticker.theme_tag_id}))
                        this.defaults.addItem(sticker, false);    
                }
            }

            this.event("defaults-loaded", data);
        }
    }

    addThemeTag(sticker, themetag)
    {
        sticker.tags.addItem( themetag, true );
        
        let last = this.stickersTag.find({theme_tag_id : themetag.id}, true).length;

        let obj = this.stickersTag.find({theme_sticker_id : sticker.id, theme_tag_id : themetag.id});
        if (!obj)
            this.stickersTag.addItem( new models.ThemeStickerTag({theme_sticker_id : sticker.id, theme_tag_id : themetag.id, position : last}) );
        
        this.updateTagsPosition(themetag.id);
    }

    removeThemeTag(sticker, themetag)
    {
        let tag = sticker.tags.find({id : themetag.id});
        
        if (tag)
            sticker.tags.removeItem( tag );

        let currentSticker = this.find({ id : sticker.id});
        if (currentSticker)
        {
            let tag = currentSticker.tags.find({id : themetag.id});
        
            if (tag)
                currentSticker.tags.removeItem( tag );
        }

        let obj = this.stickersTag.find({theme_sticker_id : sticker.id, theme_tag_id : themetag.id});
        if (obj)
        {
            this.stickersTag.removeItem(obj);
            obj.delete();
        }

        let defaultSticker = this.defaults.find({id : sticker.id, theme_tag_id : sticker.theme_tag_id});
        if (defaultSticker)
            this.defaults.removeItem(defaultSticker);

        this.updateTagsPosition(themetag.id);
    }

    updateTagsPosition(themetagid)
    {
        let stickerTags = this.stickersTag.find({theme_tag_id : themetagid}, true);
        stickerTags.sort(function(a, b){ return a.position - b.position});
        for (let i = 0; i < stickerTags.length; i++)
            stickerTags.getItemAt(i).position = i;
    }


    /******************************* Tags ****************************/
    searchTags(search, callback)
    {
        if ( this._cacheTagsSearch[search] )
        {
            this._searchedStickerTags(search, callback, this._cacheTagsSearch[search]);
        }
        else
        {
            this._searchedStickerTagsHandler = this._searchedStickerTags.bind(this, search, callback);
            this.post(  { 
                            action:"tags", 
                            search : search,
                            all : (fx.get("app") == "config") ? 1 : 0,
                            idlang : fx.service("LangService").current.id 
                        }, 
                        this._searchedStickerTagsHandler);
        }
    }

    _searchedStickerTags(search, callback, data)
    {
        let result = [];
        if (this._cacheTagsSearch[search])
            result = data;
        else
            for(let i = 0; i < data.length; i++)
                result.push({label : data[i]});
        
        this._searchedStickerTagsHandler = null;
        this._cacheTagsSearch[search] = result;

        if (callback) callback(result);
    }

    /******************************* Stickers ****************************/
    search(search, from)
    {
        if (!search)
        {
            this._fromSearch = false;
            this._lastSearch = "";
            this.removeAll(true);
            this.addItem(this._recommendedStickers, true, false, false, true );

            this.trigger("loaded");
        }
        else
        {
        
            if (!from)
                this.removeAll(true);
            
            this._lastSearch = search;

            this.post(  { 
                            action:"search", 
                            search : search,
                            from : from,
                            all : (fx.get("app") == "config") ? 1 : 0,
                            idlang : fx.service("LangService").current.id 
                        }, 
                        this._searched);
        
        }
    }
    
    _searched(data)
    {
        if (!data.error)
        {
            // let's update number from existing ones
            for (let i = 0; i < data.data.length; i++)
            {
                let sticker = data.data[i];
                let st = this._recommendedStickers.find({id : sticker.id})
                if (st)
                {
                    // let replace it
                    //sticker.number = bg.number;
                    data.data.splice(i, 1, st);
                }
            }

            this._loading = false;

            this._fromSearch = data.more;

            this.addItem( data.data, true, false, false, true );
        }

        this.trigger("loaded");
    }

    // ------------ more
    loadMore(book)
    {
        if (this._loading) return;

        if (this._lastSearch === "")
        {
            this.loadRecommended(book);
        }
        else
        {
            //this._loadingMore = true;
            this.search(this._lastSearch, this._fromSearch);
        }
    }

    use(id, use)
    {
        let sticker = this.find({id : id});

        if (!sticker)
            return;
        
        sticker.number = use ? (sticker.number + 1) : Math.max(1, sticker.number - 1);

         // case when a sticker from search is used
        // we add it to recommended (used and/or theme_category) stickers
        // we never remove it, because it could be a theme_category one
        if (use)
        {
            if (sticker.number > 0 )
            {
                if (!this._recommendedStickers.find({id : id}))
                    this._recommendedStickers.addItem(sticker);
            }
                
        }

        // to force grid to update
        this.trigger({type:"updated", action : new fx.Action("update", this, this)});
    }

    find(obj)
    {
        let sticker = super.find(obj);

        if (!sticker && this._lastSearch)
            sticker = this._recommendedStickers.find(obj)

        return sticker;
    }


    onDataEvent(e)
    {
        let sticker = e.model;

        if(e.type == "position-up")
        {
            let index = this.defaults.indexOf( sticker );
            if (index > 0)
            {
                let previousSticker = this.defaults.getItemAt( index - 1);
                let actualPosition = sticker.position;
                sticker.position = previousSticker.position;
                previousSticker.position = actualPosition;

                this.updateStickerPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-down")
        {
            let index = this.defaults.indexOf( sticker );
            if (index < this.defaults.length-1)
            {
                let previousSticker = this.defaults.getItemAt( index + 1);
                let actualPosition = sticker.position;
                sticker.position = previousSticker.position;
                previousSticker.position = actualPosition;

                this.updateStickerPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-up-10")
        {
            let index = this.defaults.indexOf( sticker );
            if (index > 0)
            {
                let previousSticker = this.defaults.getItemAt( Math.max(0, index - 10));
                sticker.position = previousSticker.position - 0.5;
                
                this.updateStickerPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-down-10")
        {
            let index = this.defaults.indexOf( sticker );
            if (index < this.defaults.length-1)
            {
                let previousSticker = this.defaults.getItemAt( Math.min( this.defaults.length-1, index + 10));
                sticker.position = previousSticker.position + 0.5;
                
                this.updateStickerPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-first")
        {
            let index = this.defaults.indexOf( sticker );
            if (index > 0)
            {
                let previousSticker = this.defaults.getItemAt( 0);
                sticker.position = previousSticker.position - 1;
                
                this.updateStickerPosition();
                this.event("position-updated");
            }
        }
        else
        if(e.type == "position-last")
        {
            let index = this.defaults.indexOf( sticker );
            if (index < this.defaults.length-1)
            {
                let previousSticker = this.defaults.getItemAt( this.defaults.length-1);
                sticker.position = previousSticker.position + 1;
                
                this.updateStickerPosition();
                this.event("position-updated");
            }
        }
    }

    updateStickerPosition()
    {
        this.defaults.sort(function(a, b){ return a.position - b.position});

        for (let i = 0; i < this.defaults.length; i++)
        {
            let sticker = this.defaults.getItemAt(i);
            sticker.position = i;

            let stickerTag = this.stickersTag.find({ theme_tag_id : sticker.theme_tag_id, theme_sticker_id : sticker.id});
            stickerTag.position = i;
        }
    }

    _sortByPosition(a, b)
    {
        /*if (a.id < b.id)
            return -1;
        if (a.id > b.id)
            return 1;
        return 0;*/

        if (a.position !== undefined && a.position !== undefined)
            return a.position - b.position;
        else
            return a.id - b.id;
    }

});